import { Product } from "../../pages/product/Product";

const initState:any = {};

const authReducer = (state = initState, action) => {
    return state;
}

export default authReducer;